import { Card, Stack, Typography, Divider } from '@mui/material';
import { ReactElement } from 'react';

import { SlideProductImage } from '@app/components/Company/SlideProductImage';
import { NavigateDetailProductButton } from '@app/components/Product/NavigateDetailProductButton';
import { ShowroomList } from '@app/components/Product/ShowroomList';
import { OrganizationStrengthsSection } from '@app/components/Product/StrengthsSection';
import { useDeviceType } from '@app/hooks/useBrowserHooks';
import { theme } from '@app/theme';
import { Organization } from '@app/types/organization';

interface ResultOrganizationCardProps {
  onClick?: () => void;
  organization: Organization;
}

export function ResultOrganizationCard({
  onClick,
  organization,
}: ResultOrganizationCardProps): ReactElement {
  const { isDesktop, isMobile } = useDeviceType();
  return (
    <Card
      sx={{
        border: `1px solid #ddd`,
        borderRadius: 4,
        boxShadow: '5px 5px 16px rgba(0, 0, 0, 0.1)',
        cursor: onClick ? 'pointer' : 'default',
        px: { sm: 4, xs: 1 },
        py: 3,
        width: '100%',
      }}
      data-e2e="searchResult-listItem"
    >
      <Stack spacing={2} sx={{ p: 2 }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Typography
            color={theme.palette.primary.dark}
            fontSize={32}
            fontWeight="bold"
          >
            {organization.name}
          </Typography>
          {isDesktop && <NavigateDetailProductButton onClick={onClick} />}
        </Stack>
        <Divider
          sx={{ borderColor: theme.palette.blueAccent.main, mb: 2, mt: 1 }}
        />

        <SlideProductImage
          images={
            organization?.customFields?.mainImages
              ?.map((img) => img.url)
              .filter((url): url is string => !!url) || []
          }
        />

        <OrganizationStrengthsSection
          features={organization.customFields?.features || []}
          strengthsTitle={organization.customFields?.mainCatch || ''}
          strengthsDescription={organization.customFields?.subCatch || ''}
          showReadMore={true}
        />

        <ShowroomList organizationId={organization.id} />
        {isMobile && <NavigateDetailProductButton onClick={onClick} />}
      </Stack>
    </Card>
  );
}
